<template>
  <div class="app-container pull-auto">
    <!-- 顶部按钮 -->
    <div style="display: flex; align-items: center;margin-bottom: 20px;">
      <!-- 今年已付金额 -->
      <div class="top-block">
        <div>今年已付金额</div>
        <div class="fz-20">
          <a>￥</a>
          <a class="numcolor">{{ledgersList.paid}}</a>
        </div>
        <div class="tonext" @click="toInvoicePage">
          <span>前往开票</span>
          <img src="../../../../public/img/next.png" alt="">
        </div>
      </div>
      <!-- 今年待付金额 -->
      <div class="top-block" style="height: 86px;box-sizing: border-box;">
        <div>今年待付金额</div>
        <div class="fz-20">
          <a>￥</a>
          <a class="numcolor">{{ledgersList.unpaid}}</a>
        </div>
      </div>
    </div>

    <!--功能按钮组件页面-->
    <avue-crud :data="tableData" :option="billTableOption" :page="page" @size-change="sizeChange" @current-change="currentChange"
      @search-reset="searchReset" @row-click="showRow" @search-change="searchChange">
      <template slot="search">
        <el-form-item label="项目信息">
          <el-input placeholder="请输入工程名称或工程地址" v-model="form.condition" clearable></el-input>
        </el-form-item>
        <el-form-item label="开工时间" class="searchdata">
          <el-date-picker v-model="form.time" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
            style="width:160px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-select v-model="form.state" placeholder="请选择" clearable>
            <el-option v-for="item in state" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot-scope="scope" slot="menuLeft">
        <el-button @click="userSee" :disabled="checkDetail" size="mini" icon="el-icon-view" type="primary">查看详情</el-button>
        <el-button @click="exportExcel" size="mini" icon="el-icon-receiving" type="primary">导出</el-button>

        <!-- <el-button  size="mini" class="filter-item" type="primary" icon="el-icon-download" @click="handleExport(scope.row)">导出</el-button> -->


      </template>

      <template slot-scope="scope" slot="projectId">
        <el-radio class="radio" v-model="radio" :label="scope.row.projectId"></el-radio>
      </template>
    </avue-crud>
    <!--任务详情-->
    <orderinfo2 ref="child" @refresh="refresh"></orderinfo2>
  </div>
</template>

<script>
  import {
    fetchFinanceList,
    getProjectLedgersForYear,
    exportProjectLedgers
  } from '@/api/admin/financeManagement'
  import {
    billOption
  } from '@/const/asset/base/manufacturerinfo'
  import {
    objKeySort
  } from '@/util/ajaxsign'
  import {
    getDateStr
  } from "@/util/date";
  import orderinfo2 from '../../orderManager/orderinfo2.vue'
  import '../../../styles/table.css';
  export default {
    name: 'billmanagement',
    components: {
      orderinfo2
    },
    data() {
      return {
        ledgersList: {},
        listQuery: {
          current: 1,
          size: 10,
          total: 0,
        },
        // 搜索
        form: {
          time: '',
          state: '',
          condition: ''
        },
        state: [{
            label: "已支付",
            value: 1
          },
          {
            label: "未支付",
            value: 0
          }
        ],
        radio: '',
        checkDetail: true,//按钮禁用开关
        add: false,
        tableData: [],
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableLoading: false,
        billTableOption: billOption,
        userInfo: '',
        isAdmin: false,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    created() {
      this.getProjectLedgers();
      this.getList();
      this.getcompany();
    },
    mounted: function() {
    },
    computed: {},
    methods: {
      //刷新列表操作
      refresh() {
        this.getList();
        this.checkDetail = true;
      },

      // 查看工程详情
      userSee() {
        this.$refs.child.setsataus(this.radio, this.cancelStateus, true);
      },

      //添加日志
      addrecord() {
        this.$refs.childinsert.insertstate(this.radio);
      },

      showRow(row) {
        this.radio = row.projectId;
        this.handleRowClick(row);
      },
      // 获取当前行数据
      handleRowClick(row) {
        let that = this
        if (row) {
          that.checkDetail = false
        } else {
          that.checkDetail = true
        }
      },
      // 提交搜索
      searchChange() {
        this.getList();
      },
      //清空收缩条件
      searchReset() {
        this.form = {};
        this.listQuery.current = 1;
        this.listQuery.size = 10;
        this.getList();
      },
      getList() {
        let that = this
        that.tableLoading = true;
        that.radio = undefined;
        let data = {
          pageNum: that.listQuery.current,
          pageSize: that.listQuery.size,
          state: that.form.state,
          condition: that.form.condition
        }
        if (that.form.time) {
          data.startDate = that.form.time[0];
          data.stopDate = that.form.time[1];
        }
        console.log(data)
        fetchFinanceList(objKeySort(data)).then(response => {
          if (response.data.code == 200) {
            that.tableData = response.data.data.rows
            that.page.total = response.data.data.total
            that.tableLoading = false
          }
        })
      },
      getProjectLedgers() {
        let that = this
        getProjectLedgersForYear(objKeySort({})).then(response => {
          if (response.data.code == 200) {
            that.ledgersList.paid = response.data.data.paid
            that.ledgersList.unpaid = response.data.data.unpaid
          }
        })
      },
      sizeChange(val) {
        this.listQuery.size = val;
        this.page.pageSize = val;
        this.listQuery.current = 1;
        this.getList()
      },
      currentChange(val) {
        this.listQuery.current = val;
        this.page.currentPage = val;
        this.getList()
      },

      toInvoicePage() {
        this.$router.push("/finance/invoiceManagement");
      },
      /**
       * 刷新回调
       */
      refreshChange() {
        this.getList()
      },

      //获取个人信息
      getcompany() {
        let that = this
        that.userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"))
        let company = that.userInfo.company != null ? that.userInfo.company : undefined;
        if (company != undefined) {
          if (company.userId == that.userInfo.id) {
            that.isAdmin = true;
          }
        }
      },
      //导出 Excel
      exportExcel() {
        let that=this
        that.tableLoading = true;
        that.radio = undefined;
        let data = {
          pageNum: that.listQuery.current,
          pageSize: that.listQuery.size,
          state: that.form.state,
          condition: that.form.condition
        }
        if (that.form.time) {
          data.startDate = that.form.time[0];
          data.stopDate = that.form.time[1];
        }
        exportProjectLedgers(objKeySort(data)).then(res=>{
          if(res.status==200){
             let blob = new Blob([res.data], { type: "application/vnd.ms-excel" } )
             let fileName = '账单管理'+getDateStr(new Date().getTime(),0,1) + '.xls';
             if (window.navigator.msSaveOrOpenBlob) {
               navigator.msSaveBlob(blob, fileName);
             }else {
               let link = document.createElement('a')
               link.href = URL.createObjectURL(blob);
               link.download = fileName;
               document.body.appendChild(link);
               link.click()
             }
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .el-table {
    margin-top: 22px;
  }

  .el_s_left {
    float: left
  }

  .el_btn {
    clear: both;
  }

  .filter-item1 {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0 !important;
    margin-left: 0 !important;
    margin-right: 22px;
  }

  .el-radio__label {
    display: none;
  }

  .sh_tip {
    vertical-align: top;
    display: inline-block
  }

  .lf_item span:first-child {
    display: inline-block;
    width: 100px;
    vertical-align: top;
  }

  .el-form-items {
    float: left;
    width: 48% !important;
  }

  .el-form-itemss {
    width: 300px !important;
    height: 40px !important;
    background-attachment: #fff !important;
  }

  .el-form-itemss .el-input {
    outline: none !important;
  }

  .el-f-item {
    width: 100% !important;
  }

  .el-dialog__header {
    margin-bottom: 0px;
  }

  .el-tag {
    border: 0 !important;
    color: #666 !important;
    background-color: transparent;
    font-size: 14px;
  }

  .dialog-footer {
    margin-left: 0 !important;
  }

  .filter-item1 {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0 !important;
    margin-left: 0 !important;
    margin-right: 22px;
  }

  .is-required {}

  .el-dialog__footer {
    height: 120px;
  }

  .p1 {
    width: 100% !important;
  }

  .part {
    position: relative;
  }

  .el-table /deep/ .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }
  .fz-20 a{
    color: #ff5543;
    text-decoration: none;
    font-size: 14px;
  }
  .fz-20{
    text-align: center;
    line-height: 26px;
  }
  .numcolor{
    font-size: 20px !important;
  }
</style>
